import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AddItemModal } from "./components/member-profile/add-item-modal";

/**
 * Mounts the "Add …" control on a zone's list page.
 *
 * Its own root rather than part of the editor's: the list and the edit form are different pages,
 * and this is the only React on the list. No QueryClientProvider either — the modal collects a
 * name and navigates; it fetches nothing.
 *
 * ZoneList.cshtml still renders a plain link inside <noscript>, so naming and creating an item is
 * possible with scripting off. That is the same accepted limit publish, delete and reorder already
 * have on this page.
 */
const SELECTOR = ".react-member-profile-add";

const mount = () => {
  document.querySelectorAll(SELECTOR).forEach((element) => {
    const raw = element.dataset.initialProps;

    if (!raw) {
      return;
    }

    const initialProps = JSON.parse(raw);

    createRoot(element).render(
      <StrictMode>
        <AddItemModal {...initialProps} />
      </StrictMode>
    );
  });
};

export const initMemberProfileAdd = () => {
  if (document.readyState !== "loading") {
    mount();
    return;
  }

  document.addEventListener("DOMContentLoaded", mount);
};
